import Immutable from 'seamless-immutable';
import createReducer from '../../../helpers/createReducer';

/**
 * Campaign store
 */
const state = {
  campaignInfo: {},
  isCampaignActive: false,
  hasActiveCampaign: false,
  isCampaign: false,
  campaignPrompt: null
};

/**
 * Campaign reducers
 */
export default createReducer(state, {
  SET_IS_CAMPAIGN: (state, { data }) => Immutable({ ...state, isCampaign: data }),
  SET_CAMPAIGN_INFO: (state, { data }) => Immutable({ ...state, campaignInfo: data }),
  TRIGGER_CAMPAIGN: (state, { data }) => Immutable({ ...state, isCampaignActive: data }),
  SET_HAS_ACTIVE_CAMPAIGN: (state, { data }) => Immutable({ ...state, hasActiveCampaign: data }),
  SET_CAMPAIGN_PROMPT: (state, { data }) => Immutable({ ...state, campaignPrompt: data })
});
